export default "__VITE_ASSET__ChjgVuxF__"